import { UploadService } from './../../services/upload.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Component, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from '../navbar/navbar.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
  standalone: true,
  selector: 'app-normal_mode_output',
  templateUrl: './normal_mode_output.component.html',
  styleUrls: ['./normal_mode_output.component.css'],
  imports: [
    MatCardModule,
    MatIconModule,
    MatTableModule,
    CommonModule,
    NavbarComponent,
    MatButtonModule,
    MatTooltipModule,
  ],
})
export class Normal_mode_outputComponent implements OnInit {
  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<any>();
  csvData: any;

  constructor(private router: Router, private uploadService: UploadService) {}

  ngOnInit() {
    this.fetchCSVData();
  }

  fetchCSVData() {
    // Call the new API to fetch normal mode data
    // this.uploadService.fetchNormalModeData().subscribe(
    //   (data) => {
    //     console.log('API Response from fetchNormalModeData:', data);

    //     if (!data || data.length === 0) {
    //       console.error('No data received from API!');
    //       return;
    //     }

    //     this.displayedColumns = Object.keys(data[0]);
    //     this.csvData = data;
    //     this.dataSource.data = this.csvData;

    //     console.log('Displayed Columns:', this.displayedColumns);
    //     console.log('Updated DataSource:', this.dataSource.data);
    //   },
    //   (error) => {
    //     console.error('API Error:', error);
    //   }
    // );

    // Static Data Implementation (Comment out when using API)

    const productData = [
      {
        "EFFECTIVE_DATE": "12/31/2025",
        "PART_NUMBER": "112FGT345",
        "PRICE": "121.98",
        "PRODUCT_ID": "A1B2C3"
      },
      {
        "EFFECTIVE_DATE": "1/1/2026",
        "PART_NUMBER": "112FGT346",
        "PRICE": "134.98",
        "PRODUCT_ID": "A1B2C4"
      },
      {
        "EFFECTIVE_DATE": "1/2/2026",
        "PART_NUMBER": "112FGT347",
        "PRICE": "149.57",
        "PRODUCT_ID": "A1B2C5"
      },
      {
        "EFFECTIVE_DATE": "1/3/2026",
        "PART_NUMBER": "112FGT348",
        "PRICE": "121.98",
        "PRODUCT_ID": "A1B2C6"
      },
      {
        "EFFECTIVE_DATE": "1/4/2026",
        "PART_NUMBER": "112FGT349",
        "PRICE": "121.98",
        "PRODUCT_ID": "A1B2C7"
      },
      {
        "EFFECTIVE_DATE": "1/5/2026",
        "PART_NUMBER": "112FGT350",
        "PRICE": "121.98",
        "PRODUCT_ID": "A1B2C8"
      },
      {
        "EFFECTIVE_DATE": "1/6/2026",
        "PART_NUMBER": "112FGT351",
        "PRICE": "121.98",
        "PRODUCT_ID": "A1B2C9"
      },
      {
        "EFFECTIVE_DATE": "1/7/2026",
        "PART_NUMBER": "112FGT352",
        "PRICE": "121.98",
        "PRODUCT_ID": "A1B2C10"
      },
      {
        "EFFECTIVE_DATE": "1/8/2026",
        "PART_NUMBER": "112FGT353",
        "PRICE": "121.98",
        "PRODUCT_ID": "A1B2C11"
      },
      {
        "EFFECTIVE_DATE": "1/9/2026",
        "PART_NUMBER": "112FGT354",
        "PRICE": "121.98",
        "PRODUCT_ID": "A1B2C12"
      },
      {
        "EFFECTIVE_DATE": "1/10/2026",
        "PART_NUMBER": "112FGT355",
        "PRICE": "121.98",
        "PRODUCT_ID": "A1B2C13"
      },
      {
        "EFFECTIVE_DATE": "1/11/2026",
        "PART_NUMBER": "112FGT356",
        "PRICE": "121.98",
        "PRODUCT_ID": "A1B2C14"
      },
      {
        "EFFECTIVE_DATE": "1/12/2026",
        "PART_NUMBER": "112FGT357",
        "PRICE": "121.98",
        "PRODUCT_ID": "A1B2C15"
      },
      {
        "EFFECTIVE_DATE": "1/13/2026",
        "PART_NUMBER": "112FGT358",
        "PRICE": "121.98",
        "PRODUCT_ID": "A1B2C16"
      },
      {
        "EFFECTIVE_DATE": "1/14/2026",
        "PART_NUMBER": "112FGT359",
        "PRICE": "121.98",
        "PRODUCT_ID": "A1B2C17"
      },
      {
        "EFFECTIVE_DATE": "1/15/2026",
        "PART_NUMBER": "112FGT360",
        "PRICE": "121.98",
        "PRODUCT_ID": "A1B2C18"
      },
      {
        "EFFECTIVE_DATE": "1/16/2026",
        "PART_NUMBER": "112FGT361",
        "PRICE": "121.98",
        "PRODUCT_ID": "A1B2C19"
      },
      {
        "EFFECTIVE_DATE": "1/17/2026",
        "PART_NUMBER": "112FGT362",
        "PRICE": "121.98",
        "PRODUCT_ID": "A1B2C20"
      },
      {
        "EFFECTIVE_DATE": "1/18/2026",
        "PART_NUMBER": "112FGT363",
        "PRICE": "121.98",
        "PRODUCT_ID": "A1B2C21"
      }
    ];

    console.log('Using Product Data:', productData);

    if (productData.length > 0) {
      this.displayedColumns = Object.keys(productData[0]);
      this.csvData = productData;
      this.dataSource.data = this.csvData;

      console.log('Displayed Columns:', this.displayedColumns);
      console.log('Updated DataSource:', this.dataSource.data);
    } else {
      console.error('No data available!');
    }
    
  }

  isNegative(value: string): boolean {
    return parseFloat(value) < 0;
  }

  downloadCSV() {
    if (!this.dataSource.data || this.dataSource.data.length === 0) {
      console.error('No data available for download.');
      return;
    }

    const headers = this.displayedColumns.join(',');
    const csvRows = this.dataSource.data.map((row) =>
      this.displayedColumns.map((column) => row[column]).join(',')
    );

    const csvContent =
      'data:text/csv;charset=utf-8,' + [headers, ...csvRows].join('\n');
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'product_data.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  navigateDashboard() {
    this.router.navigate(['./normal-dash-output']);
  }

  goBack() {
    this.router.navigate(['/home']);
  }
}
